import { TABLE_REPORTE_ESTADO_POR_SECTOR_DOS,
  TABLE_REPORTE_ESTADO_POR_SECTOR_UNO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_TRES,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO,
  TABLE_TOTAL_ESTADO_POR_SECTOR
} from '../../../config/tables'
import { ReporteEstadoPorSiloService } from '../../../models/ReportePorSector/ReportePorSectorService'
import { ReporteEstadoPorSiloUtils } from '../../../models/ReportePorSector/ReportePorSectorUtils'
import { COLUMNS, COLUMNS_TO_PRINT, COLUMNS_TOTALES } from './constantesTablaReportePorSector'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'

export function fetchSectores () {
  return async dispatch => {
    const tabla = [
      TABLE_REPORTE_ESTADO_POR_SECTOR_UNO,
      TABLE_REPORTE_ESTADO_POR_SECTOR_DOS,
      TABLE_REPORTE_ESTADO_POR_SECTOR_TRES,
      TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO,
      TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO
    ]
    for (let i = 1; i <= 5; i++) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tabla[i - 1]
      })
    }
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_TOTAL_ESTADO_POR_SECTOR
    })
    const parsedData = []
    const parsedDataTotales = []
    const dataTotal = []

    // Totales para el sector 1 y 2
    let metrosDeVacioTotalUnoDos = 0
    let pesoNetoTotalBaseTrigoUnoDos = 0
    let pesoNetoTotalBaseVigenteUnoDos = 0
    let pesoNetoBaseVigenteUnoDos = 0
    let espacioNetoTotalUnoDos = 0
    let espacioTotalCamionesUnoDos = 0
    // Totales para sectores 3 y 4
    let metrosDeVacioTotal = 0
    let pesoNetoTotalBaseTrigo = 0
    let pesoNetoTotalBaseVigente = 0
    let pesoNetoBaseVigente = 0
    let espacioNetoTotal = 0
    let espacioTotalCamiones = 0
    for (let i = 1; i <= 5; i++) {
      console.log('sector', i)
      const dataSilos = await ReporteEstadoPorSiloService.getReporte(i)
      console.log('data silos', dataSilos)
      const dataTotales = await ReporteEstadoPorSiloService.getReporteDeSector(i)
      console.log('data totales', dataTotales)
      parsedDataTotales[i] = dataTotales
      parsedData[i] = ReporteEstadoPorSiloUtils.parseDataCombinada(dataSilos, dataTotales)
      console.log('data parseada', parsedData[i])
      console.log('totales parseada', parsedDataTotales[i])
      if (dataTotales && dataTotales.filas) {
        dataTotales.filas.forEach((total) => {
          // Se unifican los sectores 1 y 2
          if (i <= 2) {
            metrosDeVacioTotalUnoDos += total.metrosDeVacioTotal
            pesoNetoTotalBaseTrigoUnoDos += total.pesoNetoTotalBaseTrigo
            pesoNetoTotalBaseVigenteUnoDos += total.pesoNetoTotalBaseVigente
            pesoNetoBaseVigenteUnoDos += total.pesoNetoBaseVigente
            espacioNetoTotalUnoDos += total.espacioNetoTotal
            espacioTotalCamionesUnoDos += total.espacioTotalCamiones
          }
          if (i === 2) {
            dataTotal.push({
              sector: 'S1-2',
              metrosDeVacioTotal: metrosDeVacioTotalUnoDos,
              pesoNetoTotalBaseTrigo: pesoNetoTotalBaseTrigoUnoDos,
              pesoNetoTotalBaseVigente: pesoNetoTotalBaseVigenteUnoDos,
              pesoNetoBaseVigente: pesoNetoBaseVigenteUnoDos,
              espacioNetoTotal: espacioNetoTotalUnoDos,
              espacioTotalCamiones: espacioTotalCamionesUnoDos
            })
          } else if (i > 2) {
            dataTotal.push(total)
          }
          metrosDeVacioTotal += total.metrosDeVacioTotal
          pesoNetoTotalBaseTrigo += total.pesoNetoTotalBaseTrigo
          pesoNetoTotalBaseVigente += total.pesoNetoTotalBaseVigente
          pesoNetoBaseVigente += total.pesoNetoBaseVigente
          espacioNetoTotal += total.espacioNetoTotal
          espacioTotalCamiones += total.espacioTotalCamiones
        })
      }
      const customToolbar = pdfCustomToolbarGenerator(
        `Reporte detallado de Estado por Sector ${i}`,
        parsedData[i],
        COLUMNS_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: parsedData[i],
          title: `Reporte detallado de Estado por Sector ${i}`,
          isLoading: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false
          }
        },
        id: tabla[i - 1]
      })
      // dispatch({
      //   type: 'UPDATE_MUITABLE',
      //   newState: {
      //     columns: COLUMNS_TOTALES,
      //     data: parsedDataTotales[i].filas,
      //     title: `Totales por Sector ${i}`,
      //     isLoading: false,
      //     extraOptions: {
      //       customToolbar: null,
      //       print: false,
      //       pagination: false,
      //       download: false,
      //       filter: false,
      //       search: false,
      //       viewColumns: false
      //     }
      //   },
      //   id: tablaTotales[i - 1]
      // })
    }
    dataTotal.push({
      sector: 'Total',
      metrosDeVacioTotal,
      pesoNetoTotalBaseTrigo,
      pesoNetoTotalBaseVigente,
      pesoNetoBaseVigente,
      espacioNetoTotal,
      espacioTotalCamiones
    })
    const customToolbar = pdfCustomToolbarGenerator(
      `Totales de Sectores`,
      dataTotal,
      COLUMNS_TOTALES,
      'portrait')
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: COLUMNS_TOTALES,
        data: dataTotal,
        title: `Totales de Sectores`,
        isLoading: false,
        extraOptions: {
          customToolbar,
          pagination: false,
          download: false,
          filter: false,
          search: false,
          viewColumns: false
        }
      },
      id: TABLE_TOTAL_ESTADO_POR_SECTOR
    })
  }
}
